export default __webpack_public_path__ + "static/media/pauseTimer.258d5e8a.mp3";